<template>
  <searches-groups-list-page
    resource-name="searches"
    :is-initiated="searchesAreInitiated"
    :data="searchesData"
    :no-data="searchesNoData"
    :all-loaded="searchesAllLoaded"
    can-load-more-string="searchesCanLoadMore"
    :is-busy="searchesAreBusy"
  />
</template>

<script>
// Components
import SearchesGroupsListPage from "../../components/boolean-search/SearchesGroupsListPage.vue";

// Mixins
import computedQueries from "../../mixins/boolean-search/computedQueries";

export default {
  name: "queries-list",

  mixins: [ computedQueries ],

  components: {
    SearchesGroupsListPage,
  }
}
</script>